import React from 'react'
import Arrow from '../../assets/icons/icon-arrow-up.svg'
import { useEffect, useState } from 'react'
import clsx from 'clsx'
import { EnterpriseTechnicalInformation } from '../../interfaces/enterprise/enterpriseTechnicalInformation'
import { isValidList, isValidStr } from '../../common_functions'
import { UnitType } from '../../interfaces/enterprise/enterpriseUnitType'
import { IconTitle } from '../../interfaces/enterprise/enterpriseIconTitle'
import { IconName } from '../../interfaces/enterprise/enterpriseIconName'
import enterpriseApi from '../../store/reducers/enterprise/enterpriseApi'
import SkeletonLoading from '../common/SkeletonLoading'

interface EnterpriseDetailCard {
  Title: string | undefined
  EnterpriseId: string
  Realization: string
}

enum FichaTecnicaKeys {
  Produto = 'Produto',
  Endereco = 'Endereço',
  AreaTotalDoTerreno = 'Área Total do Terreno',
  Diferenciais = 'Diferenciais',
  Proximidades = 'Proximidades',
  ViasDeAcesso = 'Vias de acesso',
  Realizacao = 'Realização',
  RegistroDeIncorporacao = 'Registro de Incorporação'
}

export default function FichaTecnica({ Title, EnterpriseId, Realization }: EnterpriseDetailCard) {
  const {
    data: dataAddress,
    isSuccess: isSuccessAddress,
    isError: isErrorAddress,
    isLoading: isLoadingAddress
  } = enterpriseApi.useGetEnterpriseAddressByIdQuery(EnterpriseId ?? '')
  const {
    data: dataInfo,
    isSuccess: isSuccessInfo,
    isError: isErrorInfo,
    isLoading: isLoadingInfo
  } = enterpriseApi.useGetEnterpriseInformationByIdQuery(EnterpriseId ?? '')
  const {
    data: dataDifferentials,
    isSuccess: isSuccessDifferentials,
    isError: isErrorDifferentials,
    isLoading: isLoadingDifferentials
  } = enterpriseApi.useGetEnterpriseDifferentialsByIdQuery(EnterpriseId ?? '')
  const {
    data: dataProximities,
    isSuccess: isSuccessProximities,
    isError: isErrorProximities,
    isLoading: isLoadingProximities
  } = enterpriseApi.useGetEnterpriseProximitiesByIdQuery(EnterpriseId ?? '')
  const {
    data: dataAdjacentsDistricts,
    isSuccess: isSuccessAdjacentsDistricts,
    isError: isErrorAdjacentsDistricts,
    isLoading: isLoadingAdjacentsDistricts
  } = enterpriseApi.useGetEnterpriseAdjacentsDistrictsByIdQuery(EnterpriseId ?? '')

  const [hiddenContent, setHiddenContent] = useState(true)
  const [dataIconsDifferentials, setDataIconsDifferentials] = useState<IconTitle[]>()
  const [dataIconsProximities, setDataIconsProximities] = useState<IconTitle[]>()
  const [fichaTecnica, setFichaTecnica] = useState<Map<string, string>>(
    new Map([
      [FichaTecnicaKeys.Produto, Title ?? ''],
      [FichaTecnicaKeys.Endereco, ''],
      [FichaTecnicaKeys.AreaTotalDoTerreno, ''],
      [FichaTecnicaKeys.Diferenciais, ''],
      [FichaTecnicaKeys.Proximidades, ''],
      [FichaTecnicaKeys.ViasDeAcesso, ''],
      [FichaTecnicaKeys.Realizacao, Realization ?? ''],
      [FichaTecnicaKeys.RegistroDeIncorporacao, '']
    ])
  )

  useEffect(() => {
    if (isSuccessDifferentials && dataDifferentials?.Data.length > 0) {
      var differentials = ''
      dataDifferentials?.Data.forEach((element, index) => {
        differentials +=
          element.Differential.Title + (index <= dataDifferentials?.Data.length - 1 ? ', ' : '')
      })
      changeFichaTecnica(FichaTecnicaKeys.Diferenciais, differentials)
    }
  }, [isSuccessDifferentials])

  useEffect(() => {
    if (isSuccessProximities && dataProximities?.Data.length > 0) {
      var proximities = ''
      dataProximities?.Data.forEach((element, index) => {
        proximities +=
          element.Proximity.Name + (index <= dataProximities?.Data.length - 1 ? ', ' : '')
      })
      changeFichaTecnica(FichaTecnicaKeys.Proximidades, proximities)
    }
  }, [isSuccessProximities])

  const isValidTotalArea = () => {
    if (isSuccessInfo) {
      try{
        let isValid = dataInfo.Data && dataInfo.Data.TotalArea && parseInt(dataInfo.Data.TotalArea) != 0
        return isValid
      }catch{
        return false
      }
    }
    return false
  }

  useEffect(() => {
    if (isSuccessInfo) {
      var area = "Não informado"
      if(isValidTotalArea()){
        area = dataInfo?.Data.TotalArea + (dataInfo?.Data.TotalArea.includes("m²") ? "" : "m²")
      }
      changeFichaTecnica(
        FichaTecnicaKeys.RegistroDeIncorporacao,
        dataInfo?.Data.IncorporationRegistration ?? ''
      )
      changeFichaTecnica(FichaTecnicaKeys.AreaTotalDoTerreno, area)
    }
  }, [isSuccessInfo])

  useEffect(() => {
    if (isSuccessAddress) changeFichaTecnica(FichaTecnicaKeys.Endereco, dataAddress?.Data.Location)
  }, [isSuccessAddress])

  useEffect(() => {
    if (isSuccessAdjacentsDistricts) {
      {
        var vias = ''
        dataAdjacentsDistricts?.Data?.map((item, i) => {
          vias += `${item.District.Name}${i < dataAdjacentsDistricts?.Data.length - 1 ? ', ' : ''}`
        })
        changeFichaTecnica(FichaTecnicaKeys.ViasDeAcesso, vias)
      }
    }
  }, [isSuccessAdjacentsDistricts])

  const getTotalArea = () => {
    if (isSuccessInfo) {
      if (parseInt(dataInfo?.Data.TotalArea)) {
        return `${parseInt(dataInfo?.Data.TotalArea)}m²`
      } else {
        return dataInfo?.Data.TotalArea
      }
    }
    return ''
  }

  const changeFichaTecnica = (key: string, value: string) => {
    setFichaTecnica((prevFichaTecnica) => {
      const newFichaTecnica = new Map(prevFichaTecnica)
      newFichaTecnica.set(key, value)
      return newFichaTecnica
    })
  }

  return (
    <>
      <section
        className="border border-gray-200 rounded-xl p-4"
        id="navInternEnterpriseTechnicalInfos"
      >
        <h3 className="text-lg text-[#4D4D4D] fw-semibold mb-3">Ficha Técnica</h3>
        <div className="">
          <div className="relative overflow-x-auto">
            {fichaTecnica && (
              <>
                <table className="w-full text-sm text-left text-black">
                  <tbody className="text-sm">
                    {Array.from(fichaTecnica).map(([key, value]) => {
                      return (
                        <>
                          {value && value != '' && (
                            <tr>
                              <th
                                scope="col"
                                className="px-1 py-2 fw-semibold bg-[#F6F8F9] border border-gray-200"
                              >
                                {key}
                              </th>
                              <th
                                scope="col"
                                className="px-1 py-2 border border-gray-200 fw-light"
                              >
                                {value}
                              </th>
                            </tr>
                          )}
                        </>
                      )
                    })}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
